import { CreatorViewDetailPage } from './CreatorViewDetail.page';

export const creatorViewDetailRouter = {
  '/@/creator_views/:creator_view_id': CreatorViewDetailPage,
};
